/* eslint-disable import/prefer-default-export */
import Immutable from 'seamless-immutable';
import { reducerName, createActionName } from './naming';
import * as types from './actionsTypes';
import {
  createValidateObject,
  storeSetFieldValue
} from '../../../utils/reducerHalpers/formFields';
import * as validateTypes from '../../../utils/reducerHalpers/validateTypes';

const createCommentFormReducer = name => {
  function stateDefault() {
    return {
      fields: {
        model_class: {
          title: 'Тип объекта',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        },
        model_id: {
          title: 'Id объекта',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        },
        types: {
          title: 'Причины',
          value: [],
          validate: [createValidateObject(validateTypes.REQUIRED)]
        },
        content: {
          title: 'Комментарий',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }
      },
      resultObject: {}
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(name, types.SEND_FORM):
        return state;
      case createActionName(name, types.SET_FIELD_MODEL_CLASS):
        return storeSetFieldValue(state, 'model_class', action.payload);
      case createActionName(name, types.SET_FIELD_MODEL_ID):
        return storeSetFieldValue(state, 'model_id', action.payload);
      case createActionName(name, types.SET_FIELD_TYPES):
        return storeSetFieldValue(state, 'types', action.payload);
      case createActionName(name, types.SET_FIELD_CONTENT):
        return storeSetFieldValue(state, 'content', action.payload);
      case createActionName(name, types.SET_RESULT_OBJECT):
        return state.merge({
          resultObject: action.payload
        });
      case createActionName(name, types.INIT_STATE):
        return Immutable(stateDefault());
      default:
        return state;
    }
  };
};

export function createReduceObject(parentName) {
  const reduceObject = {};
  reduceObject[reducerName] = createCommentFormReducer(parentName);
  return reduceObject;
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/complaints/addComplaintForm/reducer.js